import useSelectedBusiness from './useSelectedBusiness';
import { SubscriptionType } from '../../types/misc';
import { isSubscriptionGreaterThanOrEqual } from '../../utils/subscriptionUtils';
import { featuresInSubscription, getMinimumSubscriptionForFeatures } from '../../utils/FeatureUtils';
import businessService from '../../services/businessService';

export default function useActiveSubscription(): SubscriptionType {
  const business = useSelectedBusiness();

  if (!business) return SubscriptionType.FREE;

  // Determine the active subscription type based on trial and subscription status
  let subscriptionType: SubscriptionType = SubscriptionType.FREE;
  if (business.trialEndDate && new Date(business.trialEndDate) > new Date()) {
    subscriptionType = business.trialType || SubscriptionType.FREE;
  } else {
    subscriptionType = business.subscription?.subscriptionType ?? SubscriptionType.FREE;
  }

  // If the business had/has subscription
  if (business.trialEndDate || business.subscription) {
    // Check if features are still available
    const requiredSubscription = getMinimumSubscriptionForFeatures(business?.features || {});
    if (!isSubscriptionGreaterThanOrEqual(subscriptionType, requiredSubscription)) {
      const { name, description, features, memberPreferences } = business;
      if (!features) return subscriptionType;
      const allowedFeatures = featuresInSubscription[subscriptionType];
      const featuresCopy = { ...features };
      Object.keys(featuresCopy).forEach((key) => {
        if (!allowedFeatures[key as keyof typeof allowedFeatures]) {
          featuresCopy[key as keyof typeof featuresCopy] = false;
        }
      });
      businessService.updateBusiness(name, description, featuresCopy, memberPreferences || {});
    }
  }

  return subscriptionType;
}
